import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';

const AccountQRText = styled.div<{ bold?: boolean }>`
  color: ${Colors['light']};
  font-family: ${(props) => (props.bold ? Fonts['bold'] : Fonts['regular'])};
  font-size: ${28 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
`;

export default AccountQRText;
